<template>
  <div class="news-container">
    <div class="news-header">
      <h1>更多资讯</h1>
      <p>新闻公告全时更新，企业动态等资讯全流通，助你把握最新动态。</p>
    </div>

    <div class="news-title-ui">
      <div class="left" @click="handleToPortal">
        <img class="back-icon" src="../../assets/img/fanhui.png" alt="" />
        返回首页
      </div>
      <div class="title">
        <div class="news-title">更多资讯</div>
        <div class="news-title-en">More news</div>
      </div>
      <div class="right"></div>
    </div>

    <div class="news-tabs">
      <div
        class="activeTab"
        :class="activeTab == 'news' ? 'activeTabActive' : ''"
        @click="handleTabChange('news')"
      >
        新闻
      </div>
      <div
        class="activeTab"
        :class="activeTab == 'announcement' ? 'activeTabActive' : ''"
        @click="handleTabChange('announcement')"
      >
        公告
      </div>
    </div>

    <div class="news-list" v-if="activeTab == 'news'">
      <div
        v-for="(item, index) in newsList"
        :key="index"
        class="news-item"
        @click="handleToDetail(item)"
      >
        <div class="news-left">
          <h3 class="news-title">{{ item.title }}</h3>
          <p class="news-content">
            {{ item.content.replace(/<[^>]+>/g, "").slice(0, 300) }}
          </p>
        </div>
        <span class="news-date" v-if="item.createTime">{{
          item.createTime.split(" ")[0]
        }}</span>
      </div>
    </div>

    <div class="announcement-list" v-if="activeTab == 'announcement'">
      <div
        v-for="(item, index) in announcementList"
        :key="index"
        class="announcement-item"
      >
        <div class="announcement-left">
          <h3 class="announcement-title">{{ item.title }}</h3>
          <p class="announcement-content">{{ item.content }}</p>
        </div>
        <span class="announcement-date" v-if="item.createTime">{{
          item.createTime.split(" ")[0]
        }}</span>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { newsPage, announcementPage } from "@/api/index";

export default {
  name: "NewsIndex",
  data() {
    return {
      activeTab: "news",
      currentPage: 1,
      pageSize: 10,
      total: 100,
      newsList: [],
      announcementList: [],
    };
  },
  created() {
    // 判断是新闻还是公告
    const tab = this.$route.query.tab;
    if (tab === "news") {
      this.activeTab = "news";
    } else if (tab === "announcement") {
      this.activeTab = "announcement";
    }
    // 获取初始数据
    this.getPageData();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPageData();
    },
    handleTabChange(tab) {
      this.activeTab = tab;
      this.currentPage = 1;
      this.getPageData();
    },
    async getPageData() {
      try {
        const params = {
          current: this.currentPage,
          size: this.pageSize,
        };
        if (this.activeTab === "news") {
          const res = await newsPage(params);
          this.newsList = res.data.records;
          this.total = res.data.total;
        } else {
          const res = await announcementPage(params);
          this.announcementList = res.data.records;
          this.total = res.data.total;
        }
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    handleToPortal() {
      this.$router.push("/portal");
    },
    handleToDetail(item) {
      this.$router.push(`/news/detail/${item.id}`);
    },
  },
};
</script>

<style scoped lang="scss">
.news-container {
  .news-tabs {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .activeTab {
    width: 160px;
    height: 36px;
    background: #e9e9e9;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #000;
    cursor: pointer;
  }
  .activeTabActive {
    background: #057bf3;
    color: #fff;
  }
  .activeTab:nth-child(1) {
    margin-right: 10px;
  }
}

.news-header {
  background: linear-gradient(to right, #1890ff, #096dd9);
  color: white;
  height: 220px;
  padding: 30px 241px;
  border-radius: 4px;
  margin-bottom: 66px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: url("../../assets/bg/xinwengbanner.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.news-header h1 {
  margin: 0;
  font-size: 48px;
}

.news-header p {
  margin: 29px 0 0;
  font-size: 16px;
  opacity: 0.8;
}

.news-title-ui {
  padding: 0 241px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .left {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #000;
    cursor: pointer;
    width: 100px;
    .back-icon {
      margin-right: 2px;
      width: 16px;
      height: 16px;
    }
  }

  .right {
    width: 100px;
  }

  .title {
    margin-bottom: 30px;
    .news-title {
      font-size: 18px;
      color: #333333;
    }
    .news-title-en {
      font-weight: bold;
      font-size: 16px;
      color: #cdcdcd;
      text-align: center;
    }
  }
}

.news-tabs {
  margin-bottom: 20px;
}

.news-list {
  padding: 0px 241px;

  .news-item {
    padding: 35px 0;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    cursor: pointer;
    .news-left {
      flex: 1;
      border-right: 1px solid #ebebeb;
    }
  }

  .news-item:hover {
    .news-title {
      color: #067bf3;
    }
  }

  .news-title {
    margin: 0;
    font-size: 16px;
    color: #333;
    font-weight: normal;
  }

  .news-content {
    width: 1264px;
    margin: 24px 0 0 0;
    color: #858585;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .news-date {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    font-size: 26px;
    color: #858484;
    margin-left: 17px;
  }
}

.announcement-list {
  padding: 0px 241px;

  .announcement-item {
    padding: 35px 0;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    .announcement-left {
      flex: 1;
      border-right: 1px solid #ebebeb;
    }
  }

  .announcement-title {
    margin: 0;
    font-size: 16px;
    color: #333;
    font-weight: normal;
  }

  .announcement-content {
    width: 1264px;
    margin: 24px 0 0 0;
    color: #858585;
    font-size: 14px;
    /* white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis; */
  }

  .announcement-date {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    font-size: 26px;
    color: #858484;
    margin-left: 17px;
  }
}

.pagination {
  margin-top: 30px;
  text-align: center;
  margin-bottom: 66px;
}
</style>
